// @flow

export type Rules = [
  {
    type:
      | 'zh_cn'
      | 'number'
      | 'en_us'
      | 'idCard'
      | 'mobile'
      | 'required'
      | 'bankCard'
      | 'regex',
    message: string,
    regex?: string | RegExp
  }
];

let validateType = {
  zh_cn: /^[\u4e00-\u9fa5]*$/,
  number: /^\d*$/,
  en_us: /^[a-zA-Z]*$/,
  idCard: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
  mobile: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
  required: /^.+$/,
  bankCard: /^(\d){15,19}$/
}

function validate (
  value: string,
  rules: Rules
): { success: boolean, message?: string } {
  for (let rule of rules) {
    let { type = 'required', message, regex } = rule
    if (typeof regex === 'string') {
      regex = new RegExp(regex)
    }
    const reg = type === 'regex' ? regex : validateType[type]
    if (!reg) {
      return { success: true }
    }
    let test = true
    if (type === 'required' || value) {
      test = reg.test(value)
    }
    if (!test) {
      return {
        success: false,
        message
      }
    }
  }
  return { success: true }
}

function validateForm (
  formValue: { [string]: any } = {},
  formRules: { [field: string]: Rules },
  exclude?: Array<string> = []
) {
  let message = {}
  let messageArray = []
  let success = true
  for (const key in formRules) {
    if (!exclude.includes(key)) {
      const fieldRules = formRules[key]
      const value = formValue[key] || ''
      const { success: fieldSuccess, message: fieldMsg } = validate(
        value,
        fieldRules
      )
      if (!fieldSuccess) {
        success = false
        message[key] = fieldMsg
        messageArray.push([fieldMsg, key])
      }
    }
  }
  return {
    success,
    message,
    messageArray
  }
}

export { validate, validateForm }



// WEBPACK FOOTER //
// ./src/frame/core/formValidate.js